import { RefObject } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { SelectInstance } from 'react-select';

export function useFocusHotkey(ref: RefObject<SelectInstance<any>>) {
  const focusSelect = () => {
    if (ref.current) {
      ref.current.focus();
    }
  };
  useHotkeys('ctrl+s', () => {
    focusSelect();
  });
}
